<template>
  <a-select
    mode="multiple"
    v-model:value="valueState"
    placeholder="Pilih Grup Pelanggan"
    allow-clear
    show-search
    not-found-content="Tidak ditemukan"
    option-filter-prop="label"
    option-label-prop="label"
    @search="onSearch"
    @blur="() => (findText = null)"
    @select="() => (findText = null)"
    v-bind="$attrs"
    :loading="loading"
    :show-arrow="true"
  >
    <a-select-option v-for="d in lists" :key="d.id" :label="d.name">
      <!-- eslint-disable vue/no-v-html -->
      <span v-html="highlight(d.name)"></span>
      <!--eslint-enable-->
    </a-select-option>
  </a-select>
</template>

<script>
import { onMounted, ref, toRefs, reactive, watch } from 'vue'
import apiClient from '@/services/axios'
import { useVModel } from '@/components/useVModel.js'
import { debounce } from 'lodash'

export default {
  props: {
    value: {
      default: () => [],
      type: Array,
    },
  },
  emits: ['update:value'],
  setup(props, { emit }) {
    const lists = ref([])
    const findText = ref(null)
    const loading = ref(false)

    const fetchLists = (q = null) => {
      loading.value = true
      apiClient
        .get('/api/filter/group-customer?', { params: { q } })
        .then(response => {
          const sorted = response.data
          lists.value = sorted.sort((a, b) =>
            a.name.toLowerCase() > b.name.toLowerCase() ? 1 : -1,
          )
        })
        .finally(() => {
          loading.value = false
        })
    }
    onMounted(() => {
      fetchLists()
    })

    const onSearch = debounce(value => {
      loading.value = true
      findText.value = value
      fetchLists(value)
    }, 300)

    const highlight = value => {
      return value.replace(new RegExp(findText.value, 'gi'), match => {
        return `<span style="background-color: yellow;">${match}</span>`
      })
    }
    return {
      lists,
      valueState: useVModel(props, 'value'),
      findText,
      highlight,
      onSearch,
      loading,
    }
  },
}
</script>

<style></style>
